// ============================================================
// NotBillable.tsx — ★ "time is billable only on a case": the ONE rule + its
// UI, shared by every window that logs chargeable time (the Add / Edit
// activity modal and the Send email window).
//
// Every bill is raised on ONE case and draws its WIP from that case's entries
// (server: invoiceController unbilledEntries / the firm WIP KPI — both
// case-scoped). So chargeable time saved with no case is a non-billable
// record: it saves and shows on the client's Activity, but never enters WIP
// or a bill. Linking a case makes it billable.
//   • isChargeableWithoutCase — the rule (billable type + time + no case);
//   • NotBillableNote — the red inline text on the case field;
//   • NonBillableConfirm — the "save as non-billable?" confirm on save.
// ============================================================
import React from 'react'
import ConfirmDialogue from './ConfirmDialogue'

export const isChargeableWithoutCase = (billableType: boolean, seconds: number, caseId: string | null | undefined): boolean =>
  billableType && seconds > 0 && !caseId

export const NOT_BILLABLE_NOTE = 'Not billable — link a case to bill this time.'

// Red inline text under the case field. `id` → the field's aria-describedby.
export const NotBillableNote: React.FC<{ id: string; className?: string; children?: React.ReactNode }> = ({ id, className = '', children }) => (
  <span id={id} role="status" className={`text-[12.5px] font-medium text-casevo-danger ${className}`}>{children ?? NOT_BILLABLE_NOTE}</span>
)

// The confirm on save. confirmLabel names the action ("Save …" / "Send …").
export const NonBillableConfirm: React.FC<{ isOpen: boolean; onConfirm: () => void; onCancel: () => void; confirmLabel?: string }> = ({
  isOpen, onConfirm, onCancel, confirmLabel = 'Save as non-billable',
}) => (
  <ConfirmDialogue
    isOpen={isOpen}
    tone="primary"
    title="Save as non-billable?"
    message="This won’t be billable because it isn’t linked to a case. Save as non-billable?"
    confirmLabel={confirmLabel}
    cancelLabel="Go back"
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
)
